import React from "react";
import { Typography, Box } from "@mui/material";
import CallIcon from "@mui/icons-material/Call";
import EmailIcon from "@mui/icons-material/Email";
import { NavLink } from "react-router-dom";

const ContactForm = () => {
    return (
        <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" } }}>

            {/* Phone */}
            <Box
                sx={{
                    mb: { xs: 1, sm: 1 },
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    p: 3,
                    backgroundColor: "#d2e4ff",
                    mx: "4px",
                    "&:hover": {
                        borderRadius: 2,
                        boxShadow: 4,
                    }
                }}
            >

                <Typography
                    variant="subtitle1"
                    color="textPrimary.main"
                    sx={{
                        fontSize: { xs: "8px", sm: "10px" },
                        fontWeight: { xs: 600, sm: 400 },
                        minWidth: { xs: "20px", sm: "100%" },
                        textTransform: "uppercase",
                        color: "textPrimary.main",
                        textAlign: "center",
                    }}
                >
                    Phone number
                </Typography>

                <Box sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                }}>

                    <Box sx={{ minWidth: { xs: "30px", sm: "30px" } }}>
                        <CallIcon sx={{
                            color: 'primary.main',
                            width: { xs: "18px", sm: "20px", lg: "28px" }
                        }} />
                    </Box>
                    {/* <Box>
                        <NavLink
                            to="tel:+9718742998998"
                            underline="hover"
                            style={{ textDecoration: 'none' }}
                        >
                            <Typography
                                variant="subtitle1"
                                color="primary.main"
                                sx={{
                                    fontSize: { xs: "11.5px", sm: "13.5px" },
                                    fontWeight: 400,
                                    textTransform: "capitalize",
                                }}
                            >
                                +971 8742998998
                            </Typography>
                        </NavLink>
                    </Box> */}
                </Box>
            </Box>

            {/* Email */}
            <Box
                sx={{
                    mb: { xs: 1, sm: 1 },
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    mx: "4px",
                    p: 3,
                    backgroundColor: "#d2e4ff",
                    "&:hover": {
                        borderRadius: 2,
                        boxShadow: 4,
                    }
                }}
            >

                <Typography
                    variant="subtitle1"
                    color="textPrimary.main"
                    sx={{
                        fontSize: { xs: "8px", sm: "10px" },
                        fontWeight: { xs: 600, sm: 400 },
                        minWidth: { xs: "20px", sm: "100%" },
                        textTransform: "uppercase",
                        color: "textPrimary.main",
                        textAlign: "center",
                    }}
                >
                    Email
                </Typography>


                <Box sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                }}>

                    <Box sx={{ minWidth: { xs: "30px", sm: "30px" } }}>
                        <EmailIcon sx={{
                            color: { xs: "primary.main", sm: "primary.main" },
                            width: { xs: "18px", sm: "20px", lg: "1em" }
                        }} />
                    </Box>
                    <Box>
                        <NavLink
                            to="mailto:support@99gift.ae"
                            style={{ textDecoration: 'none' }}
                        >
                            <Typography
                                variant="subtitle1"
                                color="primary.main"
                                sx={{
                                    fontSize: { xs: "11.5px", sm: "13.5px" },
                                    fontWeight: 400,
                                    textTransform: "lowercase",
                                }}
                            >
                                support@99gift.ae
                            </Typography>
                        </NavLink>
                    </Box>

                </Box>
            </Box>

        </Box>
    );
}

export default ContactForm;
